import styled from '@emotion/styled/macro';
import { Button, ButtonProps } from 'react-bootstrap';

interface IButtonProps {
  margin?: string;
}

interface LinkButtonProps extends ButtonProps {
  clicked?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export const LinkButton = ({ clicked, className = '', children, ...rest }: LinkButtonProps) => (
  <Button
    variant="link"
    bsPrefix="override"
    className={`link no-btn font-size-xs ${className}`}
    onClick={clicked}
    {...rest}
  >
    {children}
  </Button>
);

export const ActionButton = styled(Button)`
  margin: ${({ margin }: IButtonProps) => margin || '0'};
`;
